export const DELETE_VIDEO_CONFIRM_NSG = "해당 영상을 삭제하시겠습니까?";
export const VIDEO_SAVE_CANCEL_CONFIRM_MSG = "저장을 취소하시겠습니까?";
